"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const cheminfo_font_1 = require("cheminfo-font");
const get_1 = __importDefault(require("lodash/get"));
const nmr_processing_1 = require("nmr-processing");
const fa_1 = require("react-icons/fa");
const im_1 = require("react-icons/im");
const clipboardComponents_1 = require("../../../utils/clipboard/clipboardComponents");
const clipboardHooks_1 = require("../../../utils/clipboard/clipboardHooks");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const ActiveButton_1 = __importDefault(require("../../elements/ActiveButton"));
const ButtonToolTip_1 = __importDefault(require("../../elements/ButtonToolTip"));
const Alert_1 = require("../../elements/popup/Alert");
const Modal_1 = require("../../elements/popup/Modal");
const useActiveSpectrumRangesViewState_1 = require("../../hooks/useActiveSpectrumRangesViewState");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const CopyClipboardModal_1 = __importDefault(require("../../modal/CopyClipboardModal"));
const ChangeSumModal_1 = __importDefault(require("../../modal/changeSum/ChangeSumModal"));
const PeaksToggleActions_1 = require("../PeaksPanel/PeaksToggleActions");
const DefaultPanelHeader_1 = __importStar(require("../header/DefaultPanelHeader"));
const style = (0, react_1.css) `
  .btn {
    background-color: transparent;
    border: none;
  }

  .icon svg {
    font-size: 12px;
  }

  .preview-publication-icon svg {
    font-size: 13px;
  }

  button {
    margin-right: 2px;
  }
`;
function RangesHeader({ ranges, info, onUnlink, onFilterActivated, onSettingClick, isFilterActive, filterCounter, activeTab, }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const alert = (0, Alert_1.useAlert)();
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const currentSum = (0, get_1.default)(ranges, 'options.sum', null);
    const rangesPreferences = (0, usePanelPreferences_1.usePanelPreferences)('ranges', activeTab);
    const { showMultiplicityTrees, showJGraph, showRangesIntegrals, showPeaks, displayingMode, } = (0, useActiveSpectrumRangesViewState_1.useActiveSpectrumRangesViewState)();
    function changeRangesSumHandler(options) {
        dispatch({ type: 'CHANGE_RANGE_SUM', payload: { options } });
        modal.close();
    }
    function removeAssignments() {
        onUnlink();
    }
    function handleOnRemoveAssignments() {
        modal.showConfirmDialog({
            message: 'All assignments will be removed. Are you sure?',
            buttons: [{ text: 'Yes', handler: removeAssignments }, { text: 'No' }],
        });
    }
    function handleDeleteAll() {
        modal.showConfirmDialog({
            message: 'All ranges will be deleted. Are You sure?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        dispatch({
                            type: 'DELETE_RANGE',
                            payload: { assignmentData },
                        });
                    },
                },
                { text: 'No' },
            ],
        });
    }
    function handleSetShowMultiplicityTrees() {
        dispatch({
            type: 'TOGGLE_RANGES_VIEW_PROPERTY',
            payload: { key: 'showMultiplicityTrees' },
        });
    }
    function handleShowIntegrals() {
        dispatch({
            type: 'TOGGLE_RANGES_VIEW_PROPERTY',
            payload: { key: 'showRangesIntegrals' },
        });
    }
    function handleShowJGraph() {
        dispatch({
            type: 'TOGGLE_RANGES_VIEW_PROPERTY',
            payload: { key: 'showJGraph' },
        });
    }
    const { rawWriteWithType, shouldFallback, cleanShouldFallback, text } = (0, clipboardHooks_1.useClipboard)();
    function saveToClipboardHandler(value) {
        void rawWriteWithType(value, 'text/html').then(() => alert.success('Data copied to clipboard'));
    }
    function saveAsHTMLHandler() {
        if (Array.isArray(ranges?.values) && ranges.values.length > 0) {
            const { originFrequency: observedFrequency, nucleus } = info;
            const result = (0, nmr_processing_1.rangesToACS)(ranges.values, {
                nucleus,
                deltaFormat: rangesPreferences.deltaPPM.format,
                couplingFormat: rangesPreferences.coupling.format,
                observedFrequency, //400
            });
            modal.show((0, jsx_runtime_1.jsx)(CopyClipboardModal_1.default, { text: result, onCopyClick: saveToClipboardHandler, onClose: () => modal.close() }), {});
        }
    }
    function changeSumConstantFlagHandler() {
        dispatch({
            type: 'CHANGE_RANGES_SUM_FLAG',
        });
    }
    function toggleViewProperty(key) {
        dispatch({ type: 'TOGGLE_RANGES_VIEW_PROPERTY', payload: { key } });
    }
    function toggleDisplayingMode() {
        dispatch({ type: 'TOGGLE_RANGES_PEAKS_DISPLAYING_MODE' });
    }
    const hasRanges = Array.isArray(ranges?.values) && ranges.values.length > 0;
    const counter = ranges?.values?.length || 0;
    return ((0, jsx_runtime_1.jsxs)("div", { css: style, children: [(0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { counter: counter, counterLabel: (0, DefaultPanelHeader_1.createFilterLabel)(counter, isFilterActive && filterCounter), onDelete: handleDeleteAll, deleteToolTip: "Delete All Ranges", onFilter: onFilterActivated, filterToolTip: isFilterActive ? 'Show all ranges' : 'Hide ranges out of view', showSettingButton: true, onSettingClick: onSettingClick, children: [(0, jsx_runtime_1.jsx)(ButtonToolTip_1.default, { popupTitle: "Preview publication string", popupPlacement: "right", onClick: saveAsHTMLHandler, className: "btn preview-publication-icon", disabled: !hasRanges, children: (0, jsx_runtime_1.jsx)(fa_1.FaFileExport, {}) }), (0, jsx_runtime_1.jsx)(ChangeSumModal_1.default, { onSave: changeRangesSumHandler, sumType: "ranges", currentSum: currentSum, sumOptions: ranges?.options, renderButton: (onClick) => ((0, jsx_runtime_1.jsx)(ButtonToolTip_1.default, { popupTitle: currentSum
                                ? `Change ranges sum (${currentSum.toFixed(2)})`
                                : 'Change ranges sum', popupPlacement: "right", className: "btn icon", onClick: onClick, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrSum, {}) })) }), (0, jsx_runtime_1.jsx)(ButtonToolTip_1.default, { popupTitle: "Remove all assignments", popupPlacement: "right", onClick: handleOnRemoveAssignments, disabled: !hasRanges, className: "btn icon", children: (0, jsx_runtime_1.jsx)(fa_1.FaUnlink, {}) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: showMultiplicityTrees
                            ? 'Hide multiplicity trees in spectrum'
                            : 'Show multiplicity trees in spectrum', popupPlacement: "right", onClick: handleSetShowMultiplicityTrees, value: showMultiplicityTrees, disabled: !hasRanges, children: (0, jsx_runtime_1.jsx)(fa_1.FaSitemap, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: showJGraph ? 'Hide J Graph' : 'Show J Graph', popupPlacement: "right", onClick: handleShowJGraph, value: showJGraph, disabled: !hasRanges, children: (0, jsx_runtime_1.jsx)(fa_1.FaChartBar, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: showRangesIntegrals ? 'Hide integrals' : 'Show integrals', popupPlacement: "right", onClick: handleShowIntegrals, value: showRangesIntegrals, disabled: !hasRanges, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrIntegrate, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { className: "icon", popupTitle: "Fixed integration sum", popupPlacement: "right", onClick: changeSumConstantFlagHandler, value: ranges?.options?.isSumConstant, children: (0, jsx_runtime_1.jsx)(im_1.ImLink, {}) }), (0, jsx_runtime_1.jsx)(PeaksToggleActions_1.PeaksToggleActions, { disbale: !hasRanges, showPeaks: showPeaks, onShowToggle: () => toggleViewProperty('showPeaks'), displayingMode: displayingMode, onDisplayingModeToggle: toggleDisplayingMode })] }), (0, jsx_runtime_1.jsx)(clipboardComponents_1.ClipboardFallbackModal, { mode: shouldFallback, onDismiss: cleanShouldFallback, text: text, label: "Preview publication string" })] }));
}
exports.default = RangesHeader;
